import React, { Component } from 'react';
import  {
    FormControl,
    Select,
    OutlinedInput,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    TextField
} from '@mui/material';

import Currency from '../../common/Currency';
import { Months } from '../../../utils/statsFunctions';


class ChargeReceivePayment extends Component {
    state = { }
    
    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/

        if(name === "payment_amount"){
            if(regex.test(value) || value === ""){
                this.props.handleChange(name, parseFloat(value) , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
        
    render() {
        const { index, CHARGES, SALARY_CATS, EMPLOYEES, SALARIES, selected, charge, errors } = this.props;
        console.log("charge:", this.props.charge)
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
       
        return (
            <div>
                <hr/>
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <h6>Dépense {index + 1}</h6>
                    <Grid container spacing={2}>
                        <Grid item sm={8} xs={12}>
                            <FormControl required error={!!errors.payment_charge_id} variant="outlined" style={{ width:'100%'}}>
                                <InputLabel htmlFor="payment_charge_id">Charge</InputLabel>
                                <Select
                                    value={this.props.payment_charge_id || ""}
                                    onChange={this.handleChange}
                                    input={<OutlinedInput labelWidth={80} name="payment_charge_id" id="payment_charge_id" />}
                                >
                                    <MenuItem value="" />
                                    {Object.values(CHARGES).map( item => (
                                        <MenuItem 
                                            value={item.salary_line_id} 
                                            disabled={selected.includes(item.salary_line_id)}
                                        >
                                            {/* {new Date(item.salary_line_date).toLocaleDateString("fr-FR") } | { */}
                                            {SALARIES && `${Months[new Date(SALARIES[item.salary_id].salary_period_end).getMonth()]} ${new Date(SALARIES[item.salary_id].salary_period_start).getFullYear()}`} | {
                                                SALARY_CATS && EMPLOYEES && `${
                                                    item.salary_line_name && SALARY_CATS[item.salary_line_name].salary_cat_name
                                                } - ${
                                                    item.salary_line_employee && EMPLOYEES[item.salary_line_employee].employee_lastname
                                                } ${
                                                    item.salary_line_employee && EMPLOYEES[item.salary_line_employee].employee_firstname
                                                }`
                                            } | <Currency value={item.salary_line_retenue} />
                                        </MenuItem>

                                    ))}
                                </Select>
                                <FormHelperText >{errors.payment_charge_id}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item sm={4} xs={12}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="payment_amount"
                                error={!!errors.payment_amount}
                                helperText={errors.payment_amount}
                                value={this.props.payment_amount}
                                name="payment_amount"
                                label="Montant"
                                variant="outlined"  
                                type="number"          
                                style={{width:"100%"}}
                    
                            />
                            {charge && 
                                <FormHelperText >Reste à Payer : {charge.salary_line_rest_to_pay}</FormHelperText>
                            }
                        </Grid>
                    </Grid>

                </div>                
            </div>
        );
    }
}


export default ChargeReceivePayment 